import React, { useState } from 'react'

import i18n from 'i18n-literally'

import {
  Box,
  Step,
  StepLabel,
  Stepper,
} from '@mui/material'

import createLogger from '~/src/Lib/Logging'
import FacilityInfo from '~/src/Routes/Register/AccountFlow/Steps/FacilityInfo'
import Password from '~/src/Routes/Register/AccountFlow/Steps/Password'
import PersonalData from '~/src/Routes/Register/AccountFlow/Steps/PersonalData'

const displayName = 'CreateAccountFlow'
const logger = createLogger(displayName)

const FORM_VIEWS = [
  {
    key: 'PERSONAL_DETAILS',
    component: PersonalData,
    label: i18n`Personal details`
  },
  {
    key: 'FACILITY',
    component: FacilityInfo,
    label: i18n`Facility`
  },
  {
    key: 'PASSWORD',
    component: Password,
    label: i18n`Password`
  }
]

const AccountFlow = () => {
  const [activeStep, setActiveStep] = useState(0)
  const stepView = FORM_VIEWS[activeStep]
  const { component: CurrentStep } = stepView
  const handleNextStep = () => setActiveStep(activeStep + 1)
  const handleGoBackStep = () => setActiveStep(activeStep - 1)

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      gap="3rem"
    >
      <Stepper
        sx={theme => ({
          width: '15%',
          '& .MuiStepConnector-root.Mui-active .MuiStepConnector-line': {
            borderColor: theme.palette.primary.main
          },
          '& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line': {
            borderColor: theme.palette.primary.main
          }
        })}
        activeStep={activeStep}
        alternativeLabel
      >
        {FORM_VIEWS.map(({ key }) => (
          <Step key={key}>
            <StepLabel />
          </Step>
        ))}
      </Stepper>
      <CurrentStep
        activeStep={activeStep}
        handleNextStep={handleNextStep}
        handleGoBackStep={handleGoBackStep}
      />
    </Box>
  )
}

const Connected = () => (
  <AccountFlow />
)

const Memoized = React.memo(Connected)
export default Memoized
